import './DAcConfirmation.css';
import React from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { get } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import Cookies from 'js-cookie';
var DAcConfirmation = function DAcConfirmation(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    rtl = _ref.rtl;
  console.log(fields);
  var _fields$data$configur = fields.data.configuration,
    buttonLabel = _fields$data$configur.buttonLabel,
    buttonUrl = _fields$data$configur.buttonUrl,
    description = _fields$data$configur.description,
    image = _fields$data$configur.image,
    shortDescription = _fields$data$configur.shortDescription,
    title = _fields$data$configur.title,
    contentTitle = _fields$data$configur.contentTitle;
  var APPLICATION_ID = 'applicationNumber';
  var imageField = get(image, 'jss.value') || {};
  var appNumber = Cookies.get(APPLICATION_ID) || '---';
  var descriptionWithNumber = {
    value: (get(description, 'jss.value') || '').replace('$number$', appNumber)
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: fullWidthStyles
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "title h1",
    field: get(title, 'jss')
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "description",
    field: get(shortDescription, 'jss')
  })), /*#__PURE__*/React.createElement("div", {
    className: "confirmation-banner ".concat(fullWidthStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "confirmation-banner__image",
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 991px)",
    srcSet: "".concat(imageField.src)
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(imageField.src),
    alt: imageField.alt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "confirmation-banner__content"
  }, /*#__PURE__*/React.createElement(RichText, {
    tag: "h5",
    className: "confirmation-banner__title",
    field: get(contentTitle, 'jss')
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "confirmation-banner__description",
    field: descriptionWithNumber
  }), /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: get(buttonUrl, 'jss.value.href')
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn btn-secondary"
  }, get(buttonLabel, 'jss.value'))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "   ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default DAcConfirmation;
var commonStyles = "c1b3x4e1";
var fullWidthStyles = "fc3eaxr";
var rtlStyles = "r1n30ioe";
var ltrStyles = "lnpb00q";